import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faSpinner,
);
